export const ROLE_LABELS = {
  admin: "Admin",
  user: "Warranty Administrator",
  technician: "Technician",
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || "";
